/** Class representing an action button in context menu */
export class ActionButton {

    /**
     * Create an action button object
     * @param {string} label - Label of button 
     * @param {string=} icon - Name of icon png of button taken for static folder (unused)
     * @param {string} icon_class - Name of icon class in line-awesome
     * @param {function} click - Function that gets called on button click, row data passed as positional arguement
     * @param {function=} shouldRender - Function that returns a bool to determine if action button will be rendered, row data passed as positional arguement
     */
    constructor(label, icon, icon_class, click, shouldRender) {
        this.label = label;
        this.icon = icon;
        this.icon_class = icon_class;
        this.click = click;
        this.shouldRender = shouldRender || (() => true);
    }
    toString() {
        return this.label;
    }
}